import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { DashboardComponent } from "./dashboard.component";
import { ControlsModule } from "src/app/controls/controls.module";
import { SharedModule } from "../../shared/shared.module";
import { LearnsetsListComponent } from "src/app/shared/learnsets-list/learnsets-list.component";

@NgModule({
  declarations: [
    DashboardComponent
  ],
  imports: [
    CommonModule,
    ControlsModule,
    SharedModule,
    LearnsetsListComponent,
    SharedModule
  ],
  exports: [
    DashboardComponent
  ]
})
export class DashboardModule { }